import axios from 'axios'

function sendSysadmin(state) {
  return axios({
    method: 'post',
    url:'http://139.162.157.164:4583/leads/sysadmin',
    data: state
  })
}

function sendBuh(state) {
  return axios({
    method: 'post',
    url:'http://139.162.157.164:4583/leads/buh',
    data: state
  })
}

function sendSoftware(state) {
  return axios({
    method: 'post',
    url: 'http://139.162.157.164:4583/leads/software',
    data: state
  })
}

function sendEdo(state) {
  return axios({
    method: 'post',
    url: 'http://139.162.157.164:4583/leads/edo',
    data: state
  })
}

function sendOfd(formData) {
  return axios({
    method: 'post',
    url: 'https://svimuch.ru/api/connect/ofd',
    data: formData
  })
}

export {sendSysadmin, sendBuh, sendSoftware, sendEdo, sendOfd}


// WEBPACK FOOTER //
// ./src/api/send.js